import React, { useState } from 'react'

import { uniqueId } from '../../helpers'

import { useStyles } from '../../styles'
import styles from './jss/input'
import clsx from 'clsx'

export const Input = ({ className, value, label, id, valid, errorMessage, ...rest }) => {
    const classes = useStyles(styles)
    id = !id ? uniqueId() : id

    const [focus, setFocus] = useState(false)

    const rootStyle = clsx({
        [classes.root]: true,
        [classes.focus]: focus || value !== ''
    })

    const inputStyle = clsx({
        [classes.input]: true,
        [classes.inputFallback]: value !== ''
    })

    return (
        <div className={`${rootStyle} ${className}`}>
            <input
                className={inputStyle}
                id={id}
                onFocus={() => setFocus(true)}
                onBlur={() => setFocus(false)}
                value={value}
                {...rest}
            />
            <label htmlFor={id} className={classes.label}>
                {label}
            </label>
            <span />
        </div>
    )
}

Input.defaultProps = {
    label: '',
    value: '',
    className: ''
}

export default Input